app.service("ModelConstructor", ['$rootScope', '$state', '$http', 'SiteHelper', function ($rootScope, $state, $http, SiteHelper) {

    const constructor = this;

    const siteHelper = SiteHelper;

    this.extend = function (FromClass, values, ignoreKeys) {
        const ExtendedClass = function (name) {
            FromClass.apply(this, []);
            siteHelper.applyValues(this, values, ignoreKeys);
            if (arguments) {
                siteHelper.applyValues(this, arguments[0], arguments[1]);
            }
            const model = this;
            for (let key in model) {
                let value = model[key];
                if (siteHelper.isObject(value)) {
                    value = siteHelper.simpleCloneObject(value);
                } else if (siteHelper.isArray(value)) {
                    value = siteHelper.simpleCloneArray(value);
                }
                model[key] = value;
            }
            if (this.init) {
                this.init();
            }
        };
        ExtendedClass.prototype = FromClass.prototype;
        ExtendedClass.prototype.constructor = ExtendedClass;
        return ExtendedClass;
    }

    this.BaseObject = function (values, ignoreKeys) {
        siteHelper.applyValues(this, values, ignoreKeys);
        this.init = function () {
        }
        this.cloneClass = function () {
            return constructor.BaseObject;
        }
        this.clone = function (newValues, ignoreKeys) {
            const self = this.root ? this.root : this;
            return siteHelper.basicClone(self.cloneClass(), self, newValues, ignoreKeys);
        }
    }

    this.BasicModel = constructor.extend(constructor.BaseObject, {
        id: null,
        name: null,
        choice_order: [],
        choices: {},
        disabled: false,
        model_variation_id: null,
        variation_id: {},
        choiceList: function () {
            return siteHelper.createChoiceList(this.root.choices, this.root.choice_order)
        }
    });

    this.RouteModel = constructor.extend(constructor.BasicModel, {
        is_route_model: true,
        next_model_id: null,
        public_choice_ids: {},
        navigation_pointer: null,
        default_choice_id: null,
        allow_single_choice_route: false,
        stop_if_choice_route_empty: false,
    });

    this.ModelFactory = constructor.extend(constructor.BaseObject, {
        basic_model: null,
        variation_models: {},
        choices: {},
        init: function () {
            for (let choiceID in this.root.choices) {
                this.root.choices[choiceID].id = choiceID;
            }
            this.root.basic_model = this.root.birth();
            this.super();
        },
        birth: function (values) {
            return new constructor.BasicModel(values);
        },
        birthChoice: function (values) {
            return new constructor.ModelChoice(values);
        },
        validVariationPointers: function (variationIDs) {
            return null;
        },
        invalidVariationPointers: function (variationIDs) {
            return null;
        },
        getModel: function (variationIDs) {
            variationIDs = this.root.prepareVariationIDs(variationIDs);
            const modelVariationID = this.root.createModelVariationID(variationIDs);
            if (!this.root.variation_models[modelVariationID]) {
                this.root.variation_models[modelVariationID] = this.root.prepareClonedModel(variationIDs, modelVariationID);
            }
            return this.root.variation_models[modelVariationID];
        },
        clonedModel: function (variationIDs, newValues) {
            variationIDs = this.root.prepareVariationIDs(variationIDs);
            const modelVariationID = this.root.createModelVariationID(variationIDs);
            return this.root.prepareClonedModel(variationIDs, modelVariationID, newValues);
        },
        prepareClonedModel: function (variationIDs, modelVariationID, newValues) {

            const model = this.root.birth(newValues);
            model.model_variation_id = modelVariationID;
            model.variation_ids = variationIDs;
            this.root.applyModelVariation(model);
            this.root.onModelVariationApplied(model);
            return model;
        },
        prepareVariationIDs: function (variationIDs) {
            if (!variationIDs) {
                return {}
            }
            variationIDs = siteHelper.keySort(variationIDs);
            for (let pointer in variationIDs) {
                const value = variationIDs[pointer];
                if (!value && value !== 0 && value !== false) {
                    delete variationIDs[pointer];
                }
            }
            const factory = this.root
            let validPointers = factory.validVariationPointers(variationIDs);
            let invalidPointers = factory.invalidVariationPointers(variationIDs);
            if ((validPointers || invalidPointers) && factory.isRouteFactory) {
                validPointers = null;
                invalidPointers = null;
                console.warn("valid/invalid pointers unavailable for route factories")
            }
            for (let pointer in variationIDs) {
                if ((validPointers && !validPointers.includes(pointer)) || (invalidPointers && invalidPointers.includes(pointer))) {
                    delete variationIDs[pointer];
                }
            }
            return variationIDs;
        },
        createModelVariationID: function (variationIDs) {
            return siteHelper.createUniqueObjectString(variationIDs, this.root.basic_model.id);
        },
        applyModelVariation: function (model) {

        },
        onModelVariationApplied: function (model) {
            let choice;
            if (siteHelper.keyCount(model.choices) === 0 && model.choice_order.length > 0) {
                model.choices = siteHelper.cloneChoices(this.root.choices, model.choice_order);
            }

            model.public_choice_ids = {};
            for (let choiceID in model.choices) {
                choice = model.choices[choiceID];
                choice.id = choiceID;
                choice.model_id = model.id;
                if (choice.public_id) {
                    model.public_choice_ids[choice.public_id] = choiceID;
                }
                if (!choice.next_model_id) {
                    choice.next_model_id = model.next_model_id;
                }
            }
        },
    });

    this.RouteFactory = constructor.extend(constructor.ModelFactory, {
        isRouteFactory: true
    });

    this.ModelChoice = constructor.extend(constructor.BaseObject, {
        img_src: null,
        img_class: "",
        model_id: "",
        disabled: false,
        getImgSrc: function (params) {
            return this.root.img_src;
        },
        isDisabled: function () {
            return !!this.root.disabled;
        },
        cloneClass: function () {
            return constructor.ModelChoice;
        }
    });

    this.RouteChoice = constructor.extend(constructor.ModelChoice, {
        navigation_pointer: null,
        state_ids: {},
        state_values: {},
        cloneClass: function () {
            return constructor.RouteChoice;
        }
    });

    this.ListModel = constructor.extend(constructor.BaseObject, {
        list_id: 'default_list',
        in_progress: null,
        current_page: 1,
        page_size: 24,
        item_list: null,
        sort_by_key: null,
        is_reversed: false,
        response_message: "",
        filter_terms: "",
        filter_keys: {},
        init: function () {
            this.super();
            const model = this.root;
            const birthList = model.item_list;
            const birthInProgress = model.in_progress;
            model.item_list = [];
            if (birthList) {
                model.cloneList(birthList);
            }
            if (birthInProgress !== null) {
                model.in_progress = birthInProgress;
            } else {
                model.in_progress = !!model.in_progress;
            }
        },
        isDataRequired: function () {
            const model = this.root;
            return model.item_list.length === 0 && model.in_progress;
        },
        cloneList: function (fromList) {
            const model = this.root;
            model.in_progress = false;
            model.item_list.length = 0;
            for (let i = 0; i < fromList.length; i++) {
                model.item_list.push(fromList[i]);
            }
        },
        sortBy: function (pointer) {
            const model = this.root;
            if (pointer === model.sort_by_key) {
                model.is_reversed = !model.is_reversed;
            } else {
                model.is_reversed = false;
                model.sort_by_key = pointer;
            }
        }
    });

    this.SearchModel = constructor.extend(constructor.BaseObject, {
        search_terms: null,
        date_from: null,
        date_until: null,
        from: null,
        until: null,
        limit: 100,
        prepare: function () {
            const model = this.root;
            model.from = model.date_from ? (!siteHelper.isString(model.date_from) ? model.date_from.toISOString().slice(0, 10) : model.date_from) : null;
            model.until = model.date_until ? (!siteHelper.isString(model.date_until) ? model.date_until.toISOString().slice(0, 10) : model.date_until) : null;
        }
    });

}]);